// src/features/products/services/useAssignAnalystProduct.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import api from '@/lib/api'

type AssignParams = { id_product: string; id_analista: string | null }

type AssignResponse = {
  statusCode: number
  message: string
  data: { id: string; id_analista: string | null; nomeAnalista: string | null }
}

export function useAssignAnalystProduct() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation<AssignResponse, any, AssignParams>({
    mutationFn: async ({ id_product, id_analista }) => {
      if (!user || !token) throw new Error('Usuário não autenticado')
      const { data } = await api.patch<AssignResponse>(
        '/products/analista',
        { id_product, id_analista },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (!data) throw new Error('Falha ao designar analista')
      return data
    },
    onSuccess: () => {
      // a tabela usa essa query
      queryClient.invalidateQueries({ queryKey: ['productClientsUsers'] })
    }
  })
}
